import { render, staticRenderFns } from "./reportelista.vue?vue&type=template&id=6aaa9b90&scoped=true&"
import script from "./reportelista.vue?vue&type=script&lang=js&"
export * from "./reportelista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaa9b90",
  null
  
)

export default component.exports